export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10933.1881f0a1.jpg";